module.exports = __webpack_public_path__ + "img/student3.14b220e1.png";